module.exports = __webpack_public_path__ + "img/tour_1.61669605.jpg";